<template>
  <custom-callout class="mt-2" :border-color="getColor(!item.notReportedFlag)">
    <div class="row">
      <div class="col-12 pt-0">
        <div class="row">
          <div class="col-12 pt-0">
            <div class="row">
              <div class="col-8 pt-0">
                <div class="regular">
                  Escuela:
                </div>
                <div class="text-black">
                  {{ item.schoolFullName }}
                </div>
              </div>
              <div class="col-2 pt-0">
                <div class="regular text-center">
                  Disciplinas Reportadas:
                </div>
                <div class="regular text-black text-center">
                  {{ item.disciplineQty }}
                </div>
              </div>
              <div class="col-2 col-sm col-12 pt-0 d-flex justify-content-end">
                <ActionButton
                  v-if="item.notReportedFlag && item.disciplineQty == 0"
                  variant="custom-btn-return m-2"
                  @click="onReport"
                >
                  Reportar
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import { ActionButton } from '@/components/common';
import alert from '@/mixin/alert.mixin';
import statusColorMixin from '@/views/student/UnreportedDisciplines/components/statusColor';

export default {
  name: 'Row',
  mixins: [alert, statusColorMixin],
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        disciplineQty: '',
        school: '',
        notReportedFlag: true,
      }),
    },
  },
  methods: {
    async onReport() {
      let alertResponse = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea reportar la escuela con cero disciplinas?',
        'Sí',
        'No'
      );

      if (alertResponse == false) {
        return;
      }

      this.$ApiPost('/api/student/discipline/report', {
        academicYearId: this.item.academicYearId,
        schoolId: this.item.schoolId,
        notReportedFlag: !this.item.notReportedFlag,
      }).then(() => {
        this.item.notReportedFlag = false;
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
.icon-position {
  max-width: 6%;
  padding-top: 35px;
  text-align: center;
}
.force-orange {
  color: #ff7058;
}
.text-gray-l {
  color: #3f5b60;
}
.text-gray {
  color: #727272;
}
.text-black {
  color: #11291b;
}
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
}
.col-3-alt {
  max-width: 20%;
}
.shadow-icon {
  color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 50px;
  width: 34px;
}
.custom-btn-return {
  border: 1px solid #2db782;
  color: #2db782;
}

.custom-btn-return:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}
</style>
